import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { IcpFace } from '@imprivata/nucleus';
import * as actions from '../../actions';
import LogoutStyled from '../shared/LogoutStyled';
import MoreOptions from '../shared/MoreOptions';
import { doSecondFactorFailure } from '../../actions/shared';
import { handleNoCameraOnDevice } from '../../actions/chooseModality';
import { GetMessageProtocols } from '../../constants/clientProtocols';

/**
 * IcpFace Component
 */
export class IcpFacePage extends Component {

  static propTypes = {
    verifyIcpFace: PropTypes.func.isRequired,
    handleNoCameraOnDevice: PropTypes.func.isRequired,
    availableModalities: PropTypes.arrayOf(PropTypes.string),
    username: PropTypes.string,
    isLoading: PropTypes.bool,
    isCameraPresent: PropTypes.bool,
    isHelpdeskVerificationWorkflow: PropTypes.bool,
    isEpcsWorkflow: PropTypes.bool,
    isClinicalWorkflow: PropTypes.bool,
    isEpcsError: PropTypes.bool,
    errorMessage: PropTypes.array,
    /** Use Parkland custom UX */
    useCustomUX: PropTypes.bool,
  };

  getHeaderTitle = () => {
    if (this.props.isEpcsWorkflow) {
      return 'Sign order';
    }
    else if (this.props.isHelpdeskVerificationWorkflow) {
      return 'Verify identity';
    }
    else {
      return 'Log in';
    }
  };

  onSubmit = oidcAuthorizationCode => {
    this.props.verifyIcpFace(oidcAuthorizationCode);
  };

  render() {
    const {
      availableModalities, useCustomUX, modality,
    } = this.props;
    const logoutStyle = useCustomUX ? 'black' : 'white';
    const logoutComponent = <LogoutStyled type={logoutStyle} />;
    const modalities = (availableModalities) ? availableModalities.filter(e => e !== 'face' && e !== 'tempcode') : [];
    const moreOptions = (modalities.length > 0) ? <MoreOptions currentModality='face' /> : null;
    const icpFace =
      <IcpFace
        headerTitle={this.getHeaderTitle()}
        isLoading={this.props.isLoading}
        displayErrors={this.props.errorMessage}
        username={this.props.username}
        icpTenantId={this.props.icpTenantId}
        onSubmit={this.onSubmit}
        onNoCameraDevice={this.props.handleNoCameraOnDevice}
        useCustomUX={this.props.useCustomUX}
        logoutComponent={logoutComponent}
        moreOptionsLink={moreOptions}
        logout={this.props.logout}
        showCauiErrorBanner={this.props.secondFactorFailure}/>;

    return (
      <div className='content-body'>
        { modality === 'face' ? icpFace : null }
      </div>
    );
  }
}

const mapStateToProps = state => {
  const {
    isLoading, username, errorMessage, isEpcsWorkflow, isClinicalWorkflow, modality,
    icpDomainSuffix, icpTenantId, useCustomUX, availableModalities, serverState, isHelpdeskVerificationWorkflow,
    isCameraPresent,
  } = state.login;
  return {
    isLoading,
    username,
    errorMessage,
    isEpcsWorkflow,
    isClinicalWorkflow,
    icpDomainSuffix,
    icpTenantId,
    useCustomUX,
    availableModalities,
    serverState,
    modality,
    isHelpdeskVerificationWorkflow,
    isCameraPresent,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    verifyIcpFace: icpVerificationCode => {
      dispatch(actions.verifyIcpFace(icpVerificationCode) );
    },
    logout: () => {
      dispatch(actions.logout() );
    },
    secondFactorFailure: () => {
      const { GetMsgInvalidCredentials, } = GetMessageProtocols;
      dispatch(doSecondFactorFailure(GetMsgInvalidCredentials.asString) );
    },
    handleNoCameraOnDevice: (switchToAnotherModality) => {
      dispatch(handleNoCameraOnDevice(switchToAnotherModality) );
    },
  };
};

/* istanbul ignore next */


export default connect(mapStateToProps, mapDispatchToProps)(IcpFacePage);
